module.exports = __webpack_public_path__ + "static/media/Euraenergie.d773cb51.png";